import React from 'react';
import { useNavigate } from 'react-router';
import JobCard from '../JobCard';

const InferenceJobsTable = ({ jobs }) => {
  const navigate = useNavigate();

  if (jobs.length === 0) {
    return (
      <div className="text-center py-12">
        <div className="w-24 h-24 mx-auto mb-4 bg-gray-100 rounded-full flex items-center justify-center">
          <svg className="w-12 h-12 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.5} d="M9 17v-2m3 2v-4m3 4v-6m2 10H7a2 2 0 01-2-2V5a2 2 0 012-2h5.586a1 1 0 01.707.293l5.414 5.414a1 1 0 01.293.707V19a2 2 0 01-2 2z" />
          </svg>
        </div>
        <h3 className="text-lg font-medium text-gray-900 mb-2">No experiments yet</h3>
        <p className="text-gray-500">Get started by creating your first experiment.</p>
      </div>
    );
  }

  return (
    <div className="grid gap-4">
      {jobs.map((job) => (
        <JobCard
          key={job.id}
          job={job}
          onClick={() => navigate(`/jobs/${job.id}`)}
          linkTo={`/jobs/${job.id}`}
          title={job.name || `Experiment #${job.id}`}
          showDownload={true}
        />
      ))}
    </div>
  );
};

export default InferenceJobsTable;
